import styled from 'styled-components';

const AlertBlock = styled.div`
  background-color: ${props => (props.expired ? '#fff5e3' : props.theme.color.errorbg)};
  margin: 0 auto 30px;
  border-radius: 4px;
  width: 100%;
  max-width: 470px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 1em;
  box-sizing: border-box;
  p {
    margin: 0 0 0 1.2em;
    font-size: 0.875em;
    text-align: left;
  }
`;

const LoginCommonWrapper = styled.div`
  padding: 4.375em 1.5em 1.5em;
  box-sizing: border-box;
  text-align: center;
  form {
    max-width: 470px;
    width: 100%;
    display: inline-block;
    margin-bottom: 3em;
  }
  @media all and (max-width: 768px) {
    padding-top: 2.5em;
  }
  @media all and (max-width: 576px) {
    padding-top: 1.5em;
  }
  a {
    text-decoration: none;
    color: ${props => props.theme.color.primary};
    transition: opacity 0.25s ease-in-out;
    &:hover {
      opacity: 0.8;
    }
  }
`;

const MainText = styled.p`
  margin-top: 1.25em;
  margin-bottom: 2.5em;
  font-size: 1.5em;
  @media all and (max-width: 768px) {
    font-size: 1.4em;
    margin-top: 1em;
    margin-bottom: 2em;
  }
  @media all and (max-width: 576px) {
    font-size: 1.3em;
    margin-top: 0.5em;
    margin-bottom: 1.5em;
  }
`;

export { AlertBlock, LoginCommonWrapper, MainText };
